import React from 'react';
import { FN112 } from '../../../services/pwn201Api';

interface Props {
  totalCount: number;
  rows: FN112[];
  isEditing: boolean;
  onAdd: () => void;
  onDelete: (idx: number) => void;
  onChange: (idx: number, field: keyof FN112, value: unknown) => void;
}

const TabHandleDetails: React.FC<Props> = React.memo(({ totalCount, rows, isEditing, onAdd, onDelete, onChange }) => (
  <div className="pwn201-tab-content">
    <div style={{ marginBottom: 12 }}>
      <span>總項數: <strong>{totalCount}</strong></span>
    </div>
    {isEditing && (
      <div className="pwn201-tab-toolbar">
        <button onClick={onAdd} className="btn-add">+ 新增處理要求</button>
      </div>
    )}
    <table className="pwn201-grid">
      <thead>
        <tr>
          <th>序號</th>
          <th>客訴代號</th>
          <th>客訴說明</th>
          <th>幣別</th>
          <th>匯率</th>
          <th>金額</th>
          {isEditing && <th>操作</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx}>
            <td>{row.fn112_02}</td>
            <td>
              <input
                value={row.fn112_11}
                onChange={(e) => onChange(idx, 'fn112_11', e.target.value)}
                disabled={!isEditing}
                maxLength={10}
              />
            </td>
            <td>
              <input
                value={row.fn112_11a}
                onChange={(e) => onChange(idx, 'fn112_11a', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                value={row.fn112_12}
                onChange={(e) => onChange(idx, 'fn112_12', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                type="number"
                value={row.fn112_13}
                onChange={(e) => onChange(idx, 'fn112_13', parseFloat(e.target.value) || 0)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                type="number"
                value={row.fn112_14}
                onChange={(e) => onChange(idx, 'fn112_14', parseFloat(e.target.value) || 0)}
                disabled={!isEditing}
              />
            </td>
            {isEditing && (
              <td>
                <button onClick={() => onDelete(idx)} className="btn-delete">刪除</button>
              </td>
            )}
          </tr>
        ))}
        {rows.length === 0 && (
          <tr><td colSpan={isEditing ? 7 : 6} style={{ textAlign: 'center', color: '#999' }}>無資料</td></tr>
        )}
      </tbody>
    </table>
  </div>
));

export default TabHandleDetails;
